import type { OvenQueues, RoastBatch } from '../api/client';

export function ovenQueuePosition(queues: OvenQueues, batch: RoastBatch): number {
  if (batch.status !== 'planned' || !batch.machine_id) return 0;
  return (queues[batch.machine_id]?.pending_batch_ids.indexOf(batch.id) ?? -1) + 1;
}

export function ovenQueueHead(
  queues: OvenQueues,
  machineId: string,
  batches: RoastBatch[],
): RoastBatch | null {
  const id = queues[machineId]?.pending_batch_ids[0];
  return batches.find(batch => batch.id === id && batch.machine_id === machineId && batch.status === 'planned') ?? null;
}
